import { render, staticRenderFns } from "./SplashOverlay.vue?vue&type=template&id=305169a8&scoped=true"
import script from "./SplashOverlay.vue?vue&type=script&lang=js"
export * from "./SplashOverlay.vue?vue&type=script&lang=js"
import style0 from "./SplashOverlay.vue?vue&type=style&index=0&id=305169a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305169a8",
  null
  
)

export default component.exports